module.exports = {
  title: {
    home: '首页',
    productCenter: '产品中心',
    applicationVideo: '应用视频',
    aboutDongju: '关于东巨',
    contactUs: '联系我们',
    downloadCenter: '下载中心',
    cpzl: '产品资料',
    rjxz: '软件下载',
    rjxz2: '软件下载',
    qtwj: '其他文件',
    login: '登录',
    register: '注册',
    search: '搜索',
    more: '更多',
    online: '在  线  咨  询',
    dqkj: '东巨科技',
    factory: '工厂',
    equipment: '设备',
    team: '团队',
    userCenter: '个人中心',
		kfzx: '客服咨询',
    zx: '咨询',
    wxkf: '微信在线客服',
    gsjj: '公司简介',
    zycp: '主营产品',
    gsry: '公司荣誉',
    c_name: '四川东巨自动化科技有限公司',
    product: '产品下载',
    video: '视频',
    download: '下载',
    engineer: '工程师',
    purchase: '采购',
    CompanyName: '公司名称',
    address: '地址',
    contacts: '联系人',
    phone: '电话',
    email: '邮箱',
    nikename: '用户名',
    pwd: '登录密码',
    yyzh: '已有账户',
    ljdl: '立即登录',
    total: '共',
    pages: '页',
    qg: '全国经营商',
    ljcg: '立即采购',
    cpcs: '产品参数',
    model: '型号',
    trip: '行程',
    dzjd: '动作角度',
    style: '款式',
    show: '显示全部',
    put: '收起',
    yyly: '应用领域',
    price: '价格',
    cgsl: '采购数量',
    xj: '小计',
    addcars: '加入购物车',
    cpjs: '产品介绍',
    wexz: '文档下载',
    submit: '保存',
		xxcs: '详细参数',
    cpxl: '产品系列',
    xhsm: '型号说明',
    shumo: '3D数模',
    zlxz: '资料下载',
    fj: '附件',
    jj: '简介',
    bbh: '版本号',
    fbsj: '发布时间',
    wjxz: '文件下载',
    wjsm: '文件说明',
    kp: '开票信息'
  },
  content: {
    index_about_info: '四川东巨自动化科技有限公司坐落于四川省资阳市高新技术产业园，成立于 2014 年，深耕伺服电机模组研发生产二十余年，是集科研开发、生产销售、现代服务于一体的综合性企业。\n' +
      '公司配备数控机床 33 台，各类机械加工设备 90 余台，夹爪专项生产设备及实验平台 10 余台套；大专及以上学历员工占比 58%，具备雄厚的研发与生产制造实力。',
		index_down: '产品附件下载',
    about_info_2: '公司聚焦工厂自动化领域，推动软硬件标准化、模块化，提供一站式系统化解决方案，降低行业对人才、技术、设备的依赖，助力客户节约研发成本，提升设备可靠性。主要产品包含电动手指、旋转平台、微型直线滑台、高性能直线滑台、坐标机手、工业机器人等自动化装备。',
    about_info_3: '公司被评为二O一六年度“科技创新先进企业”，所有的上架产品均为自主研发生产，拥有完全独立的知识产权，产品广泛应用于生产制造、科研、军工等领域。'
  },
  tips: {
    r1: '请输入公司名称',
    r2: '请输入地址',
    r3: '请输入联系人',
    r4: '请输入联系方式',
    r5: '请输入邮箱',
    r6: '请输入用户名',
    r7: '请输入密码',
    r8: '请输入正确的邮箱',
    l1: '用户名不能为空',
    l2: '密码不能为空',
    a1: '请输入详细地址',
    a2: '请输入收货人',
    a3: '是否删除?',
    a4: '请选择收货地址',
    o1: '注：对公账户打款成功后，请将转账记录发送至邮箱',
    s1: '请输入企业名称',
    s2: '请输入纳税人识别号',
    s3: '请输入企业地址',
    s4: '请输入开户银行',
    s5: '请输入银行账号'
  },
  member: {
    gwc: '购物车',
    cgdd: '采购订单',
    shdz: '收货地址',
    tcdl: '退出登录',
    shr: '收货人',
    lxdh: '联系电话',
    edit: '修改',
    confirm: '确认',
    cancel: '取消',
    del: '删除',
    dgzhdk: '对公账户打款',
    skrhm: '收款人户名',
    yhkh: '银行账号',
    khhh: '开户行号',
    khyh: '开户银行',
    all: '全选',
    orderNum: '订单编号',
    qrsh: '确认收货',
    js: '结算',
    yl: '预览',
    cpname: '产品名称',
    allshop: '全部商品',
    ys: '已选',
    shop: '商品',
    qymc: '企业名称',
    ns: '纳税人识别号',
    qydz: '企业地址',
    tjdz: '添加地址',
    piece: '件',
    yfje: '应付金额',
    y: '元',
    skf: '收款方',
    xyb: '下一步',
    yzf: '已支付'
  }
}
